import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";

const Container = styled.div`
    border-radius: 8px;
    padding: 1em;
    background-color: ${({ theme }) => theme?.backgroundContenedor};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    @media print {
        box-sizing: border-box; 
        border: 2px solid black; 
    };
`;

const InnerDiv = styled.div`
    min-height: 20px;
`;

const Title = styled.div`
    letter-spacing: 1px;
    font-weight: 400;
    text-transform: uppercase;
    display: inline-block;
    padding: 2px 2px;
    margin-left: 0em;
    line-height: 16px;
    color: ${({ theme }) => theme?.tituloContenedor || '#3498DB'};
`;

const Contenedor = ({ children, titulo, justifyClass, color, actionButton, ...rest }) => {

    return (
        <Container
            {...rest}
        >
            {
                titulo &&
                <Row style={{marginBottom: '15px'}}>
                    <Col className={justifyClass}>
                        {
                            color
                            ?
                                <Title style={{color:color}}>{titulo}</Title>
                            :
                                <Title>{titulo}</Title>
                        }
                    </Col>
                    {
                        actionButton &&
                        <Col className='text-end'>
                            {actionButton}
                        </Col>
                    }
                </Row>
            }
            <InnerDiv>
                {children}
            </InnerDiv>
        </Container>
    )
}

export default Contenedor;